import { render, staticRenderFns } from "./CruiseDataTable.vue?vue&type=template&id=ba225ad4&"
import script from "./CruiseDataTable.vue?vue&type=script&lang=js&"
export * from "./CruiseDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports